import ApplicationSerializer from './application';

export default class VisitorProfileSerializer extends ApplicationSerializer {
  // photo-url is a read-only derived field on the backend VisitorProfileResource.
  // Sending it on PATCH causes a 500 because the resource has no corresponding setter.
  attrs = {
    photoUrl: { serialize: false },
  };
}

declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    'visitor-profile': VisitorProfileSerializer;
  }
}
